import { Client, Debouche } from '../../../common/client/client.types'

export const formatDeboucheListFromClients = (clients: Client[]) => clients
	.flatMap(client => client.deboucheList
		.flatMap(debouche => {
			const suffix = client.interne ? debouche.nom : (debouche.nom.length === 0 ? '' : ` - ${debouche.nom}`)
			return ({
				id: debouche.id,
				label: `${client.interne ? '' : (client.raisonSociale ?? '')}${suffix}`
			})
		}))

export const formatDeboucheLabel = (debouche: Debouche): string => {
	const client = debouche.client
	const suffix = client.interne ? debouche.nom : (debouche.nom.length === 0 ? '' : ` - ${debouche.nom}`)
	return `${client.interne ? '' : (client.raisonSociale ?? '')}${suffix}`
}